import { axios } from '@/services/axios';

export const deleteTemplate = (templateId) => {
    return axios.delete(`/AATemplate/${templateId}`);
};
